import styles from './PedidosCliente.module.css';
import CardUltimosPedidos from '../../../shared/components/CardUltimosPedidos';
import FooterOpcoes from '../components/FooterOpcoes';
import { useContext, useState, useEffect } from 'react';
import { PedidosContext } from '../../../shared/contexts/PedidosContext';
import { ItensPedidosContext } from '../../../shared/contexts/ItensPedidosContext';
import HeaderPagesMobile from '../../../shared/components/HeaderPagesMobile';
import { FaClipboardList } from 'react-icons/fa';

function PedidosCliente() {
  const { pedidos, atualizarPedidos } = useContext(PedidosContext);
  const { atualizarItens } = useContext(ItensPedidosContext);


      const mudarStatusPedido = async (id, novoStatus) => {
      await atualizarPedidos(); 
    };

  // Buscar pedidos e itens atualizados quando a página for acessada
  useEffect(() => {
    atualizarPedidos();
    atualizarItens();
  }, []);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);

  const idClienteLogado = localStorage.getItem("id_cliente");

  const pedidosDoCliente = pedidos.filter(
    (pedido) => String(pedido.id_cliente) === idClienteLogado
  );

  // Ordena por data, mais recente primeiro
  const pedidosOrdenados = [...pedidosDoCliente].sort(
    (a, b) => new Date(b.data_pedido) - new Date(a.data_pedido)
  );

  // Separa pedidos ativos dos cancelados
  const pedidosAtivos = pedidosOrdenados.filter(
    (p) => p.status?.toLowerCase() !== 'cancelado'
  );
  const pedidosCancelados = pedidosOrdenados.filter(
    (p) => p.status?.toLowerCase() === 'cancelado'
  );

  // Verifica se o pedido selecionado ainda é válido (não cancelado) nos dados atualizados
  const pedidoSelecionadoAtualizado = pedidoSelecionado
    ? pedidosOrdenados.find((p) => p.id_pedido === pedidoSelecionado.id_pedido)
    : null;
  const pedidoSelecionadoValido =
    pedidoSelecionadoAtualizado?.status?.toLowerCase() !== 'cancelado'
      ? pedidoSelecionadoAtualizado
      : null;

  // Pedido principal: apenas pedidos não cancelados
  let ultimoPedido = pedidosAtivos[0] || null;
  let pedidosAnteriores = [...pedidosAtivos.slice(1), ...pedidosCancelados];

  if (pedidoSelecionadoValido) {
    ultimoPedido = pedidoSelecionadoValido;
    pedidosAnteriores = [
      ...pedidosAtivos.filter((p) => p.id_pedido !== pedidoSelecionadoValido.id_pedido),
      ...pedidosCancelados
    ];
  }

  const statusEtapas = ['PENDENTE', 'EM ANDAMENTO', 'PRONTO', 'ENTREGUE'];

  return (
    <div className={styles.container}>
   
      {ultimoPedido ? (
        <div className={styles.cardPrincipal}>
          <div className={styles.cabecalhoPedido}>
            <h3>Pedido #{ultimoPedido.id_pedido}</h3>
           {/* <span className={`${styles.badge} ${styles[ultimoPedido.status?.toLowerCase().replace(/\s+/g, '')]}`}>
              {ultimoPedido.status}
            </span>*/}
          </div>
          <div>
            <p className={styles.subtitulo}>Acompanhe o status do seu pedido em tempo real</p>
            <p className={styles.dica}>Para visualizar a linha do tempo de um pedido anterior, basta clicar sobre ele.</p>
          </div>

          {/* Mostra código de entrega apenas se não estiver entregue */}
          {ultimoPedido.codigo_entrega && ultimoPedido.status?.toLowerCase() !== 'entregue' && (
            <div className={styles.codigoBox}>
              <p className={styles.codigoTexto}>
                Código de retirada: <strong>{ultimoPedido.codigo_entrega}</strong>
              </p>
              <p className={styles.codigoAviso}>
                Informe este código ao atendente no momento da retirada.
              </p>
            </div>
          )}

          {/* Linha do tempo */}
          <div className={styles.timeline}>
            {statusEtapas.map((status, index) => {
              const statusNormalized = ultimoPedido.status?.trim().toLowerCase();
              const statusAtualIndex = statusEtapas.findIndex(
                (s) => s.toLowerCase() === statusNormalized
              );

              let circleClass = styles.circle;
              let lineClass = styles.line;
              let showCheck = false;

              if (statusAtualIndex === -1) {
                circleClass = styles.circle;
              } else if (statusNormalized === 'entregue') {
                // Se entregue, todas as bolinhas ficam verdes
                circleClass = `${styles.circle} ${styles.completed}`;
                lineClass = `${styles.line} ${styles.lineCompleted}`;
                showCheck = true;
              } else if (index < statusAtualIndex) {
                circleClass = `${styles.circle} ${styles.completed}`;
                lineClass = `${styles.line} ${styles.lineCompleted}`;
                showCheck = true;
              } else if (index === statusAtualIndex) {
                circleClass = `${styles.circle} ${styles.inProgress}`;
              }

              return (
                <div key={status} className={styles.timelineStep}>
                  <div className={styles.timelineNode}>
                    <div className={circleClass}>
                      {showCheck && <span className={styles.checkIcon}>✓</span>}
                    </div>
                    {index < statusEtapas.length - 1 && <div className={lineClass}></div>}
                  </div>
                  <p className={styles.timelineLabel}>{status}</p>
                </div>
              );
            })}
          </div>

          <CardUltimosPedidos
            pedido={ultimoPedido}
            typeView="cliente"
            index={0}
            mudarStatusPedido={mudarStatusPedido}

          />
        </div>
      ) : (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>📦</div>
          <p className={styles.emptyTitle}>Nenhum pedido encontrado</p>
          <p className={styles.emptyText}>Você ainda não fez nenhum pedido.</p>
        </div>
      )}

      {pedidosAnteriores.length > 0 && (
        <>
          <h3 className={styles.sectionTitle}>Pedidos anteriores</h3>
          <div className={styles.pedidosGrid}>
            {pedidosAnteriores.map((pedido) => (
              <div
                key={pedido.id_pedido}
                className={styles.pedidoWrapper}
                onClick={() => {
                  const s = pedido.status.toLowerCase();
                  if (s !== 'entregue' && s !== 'cancelado') {
                    setPedidoSelecionado(pedido);
                  }
                }}
              >
                <CardUltimosPedidos pedido={pedido} typeView="cliente"   mudarStatusPedido={mudarStatusPedido}
 />
              </div>
            ))}
          </div>
        </>
      )}

      <FooterOpcoes typeView="cliente" />
    </div>
  );
}

export default PedidosCliente;
